module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-designs/designs-2-0d369a6225876aa3a54c1510f52c899d.jpg";